<template>
  <div class="row">
    <!-- Top Bar -->
    <div class="top-bar">
      <div><p>Tutorial screen</p></div>
      <burger/>
    </div>

    <!-- Main Content -->
    <div class="container-main">
      <div class="container-fluid right-container tutorial-container" id="items-container">
        <div class="col-md-10 offset-md-1">
          <carousel :navigationEnabled="true" :centerMode="true" paginationColor="#777777" paginationActiveColor="#ffffff" style="height: 60vh; padding: 0 60px; margin-top: 70px; text-align: center;" :perPage="1">

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1a_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1b_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1c_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1def_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1gh_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/1i_Dashboard.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Dashboard</h1>
              <p style="text-align: center">The Dashboard shows live feeds of the available cameras along with a log of the most recent people identified.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/2a_Events.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Events</h1>
              <p style="text-align: center">The Events page allows you to navigate through all of the events in the system.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/2bc_Events.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Events</h1>
              <p style="text-align: center">The Events page allows you to navigate through all of the events in the system.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/2d_Events.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Events</h1>
              <p style="text-align: center">The Events page allows you to navigate through all of the events in the system.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/2ef_Events.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Events</h1>
              <p style="text-align: center">The Events page allows you to navigate through all of the events in the system.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/2gh_Events.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Events</h1>
              <p style="text-align: center">The Events page allows you to navigate through all of the events in the system.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/3abc_Attendance.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Attendance</h1>
              <p style="text-align: center">The Attendance page shows who was present in any given location during a certain time interval.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/3d_Attendance.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Attendance</h1>
              <p style="text-align: center">The Attendance page shows who was present in any given location during a certain time interval.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/3e_Attendance.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Attendance</h1>
              <p style="text-align: center">The Attendance page shows who was present in any given location during a certain time interval.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/4a_indentity-management.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Identity management</h1>
              <p style="text-align: center">All the people tracked by the system are shown in the Identity Management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/4bc_Identity-Management.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Identity management</h1>
              <p style="text-align: center">All the people tracked by the system are shown in the Identity Management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/4de_Identity-Management.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Identity management</h1>
              <p style="text-align: center">All the people tracked by the system are shown in the Identity Management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/5a_Users.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Users</h1>
              <p style="text-align: center">Users can be managed both through the Identity Management and the Users page. From the user pages, ONLY users that can authenticate in the system are managed. This page works similarly to the Identity management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/5b_Users.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Users</h1>
              <p style="text-align: center">Users can be managed both through the Identity Management and the Users page. From the user pages, ONLY users that can authenticate in the system are managed. This page works similarly to the Identity management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/5c_Users.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Users</h1>
              <p style="text-align: center">Users can be managed both through the Identity Management and the Users page. From the user pages, ONLY users that can authenticate in the system are managed. This page works similarly to the Identity management page.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/6a_User-Actions.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">User Actions</h1>
              <p style="text-align: center">The User Actions page shows a log of who accessed the system and the changes they’ve made.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/6b_Attendance.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">User Actions</h1>
              <p style="text-align: center">The User Actions page shows a log of who accessed the system and the changes they’ve made.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/7a_cameras.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Camera settings</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/7b_Cameras.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Camera settings</h1>
              <p style="text-align: center">The Camera Settings page is used to manage locations and cameras.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/7c_Cameras.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Camera settings</h1>
              <p style="text-align: center">The Camera Settings page is used to manage locations and cameras.</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/tutorial/8a_Cameras.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">My Account</h1>
              <p style="text-align: center">A user that can authenticate in the system may change the password and email.</p>
            </slide>

          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  import Burger from '@/components/Burger';

  export default {
    name: 'Tutorial',
    components: {
      Carousel,
      Slide,
      Burger
    },
    data() {
      return {
        user: null
      };
    },
  };
</script>

<style scope>
  .VueCarousel-slide h1 {
    text-align: center;
    font-size: 24px;
  }
  .VueCarousel-slide img {
    height: 63vh; max-width: 100% !important;
  }
  .VueCarousel-slide p {
    text-align: center;
    font-size: 14px;
  }
  .VueCarousel-pagination li {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
</style>